































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {InputRelatorioAutomaticoSchema} from '@/schema/resource/RelatorioAutomatico/InputRelatorioAutomaticoSchema'
import {RelatorioAutomatico} from '@/model/resource/RelatorioAutomatico'

@Component
export default class PersistRelatorioAutomaticoView extends Vue {
  @Provide('validator') validator = this.$validator

  schema = new InputRelatorioAutomaticoSchema()
  relatorioAutomatico = new RelatorioAutomatico()

  async created() {
    await this.populate()
  }

  @Watch('relatorioAutomatico.responsavel')
  async populate() {
    const idResponsavel = this.relatorioAutomatico?.responsavel?.$id

    if (idResponsavel) {
      const resp = await this.relatorioAutomatico.getRelatorioAutomatico(
        idResponsavel
      )
      if (!resp) {
        this.relatorioAutomatico.reset()
        this.$snotify.warning(
          $.t('schema.InputRelatorioAutomatico.warning') as string
        )
      }
    } else {
      this.relatorioAutomatico.reset()
    }

    $.await.done('getRelatorioAutomatico')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.relatorioAutomatico.persistRelatorioAutomatico()
    this.$snotify.success(
      $.t('schema.InputRelatorioAutomatico.success') as string
    )
    this.relatorioAutomatico.reset()
    this.relatorioAutomatico.responsavel = null
    this.$forceUpdate()
  }

  get responsavelLabelAndValue() {
    if (this.relatorioAutomatico.responsavel?.razaoSocial) {
      return {
        label: $.t('schema.InputRelatorioAutomatico.razaoSocial'),
        value: this.relatorioAutomatico.responsavel.razaoSocial,
      }
    } else {
      return {
        label: $.t('schema.InputRelatorioAutomatico.nomeFantasia'),
        value: this.relatorioAutomatico.responsavel?.nomeFantasia,
      }
    }
  }
}
